export class AiImageUploadCommand {
    formData: FormData = new FormData();

    constructor(croppedFile: File, originalFile?: File, imageId?: string) {
        this.formData.append('file', croppedFile);
        if (originalFile) {
            this.formData.append('original', originalFile);
        }
        if (imageId) {
            this.formData.append('image_id', imageId);
        }
    }
}
